/**
 * @generated SignedSource<<5fa9992cab44f0fc8e848a4649e15211>>
 * @relayHash 911f7e6475259ca9226b417ce1d7a171
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 73217ad492b967e01ebeed7cedf9991eec990162d13ac0a42beb8f9526209dd7

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type ThemeSetterQuery$variables = {
  cloudId: string;
  projectIdOrKey: string;
  withHarmonisedTheme: boolean;
  withPersistDominantColor: boolean;
};
export type ThemeSetterQuery$data = {
  readonly jira: {
    readonly mediaClientId: string | null;
    readonly mediaExternalEndpointUrl: string | null;
  };
  readonly jira_projectByIdOrKey: {
    readonly background: {
      readonly " $fragmentSpreads": FragmentRefs<"ThemeSetterBackground">;
    } | null;
    readonly canEditProjectConfig: {
      readonly canPerform?: boolean;
    } | null;
    readonly projectId: string | null;
    readonly projectType: JiraProjectType | null;
    readonly " $fragmentSpreads": FragmentRefs<"DominantColorPersister_project">;
  } | null;
};
export type ThemeSetterQuery = {
  response: ThemeSetterQuery$data;
  variables: ThemeSetterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIdOrKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "withHarmonisedTheme"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "withPersistDominantColor"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": (v2/*: any*/),
      "kind": "ScalarField",
      "name": "mediaClientId"
    },
    {
      "args": (v2/*: any*/),
      "kind": "ScalarField",
      "name": "mediaExternalEndpointUrl"
    }
  ]
},
v4 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectIdOrKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v6 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v7 = [
  {
    "kind": "Variable",
    "name": "harmonisedTheme",
    "variableName": "withHarmonisedTheme"
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EDIT_PROJECT_CONFIG"
  }
],
v9 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
],
v10 = {
  "alias": "canEditProjectConfig",
  "args": (v8/*: any*/),
  "concreteType": "JiraProjectAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    {
      "condition": "withPersistDominantColor",
      "kind": "Condition",
      "passingValue": true,
      "selections": (v9/*: any*/)
    }
  ],
  "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ThemeSetterQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v3/*: any*/),
        "action": "THROW",
        "path": "jira"
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "args": (v7/*: any*/),
            "kind": "LinkedField",
            "name": "background",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ThemeSetterBackground"
              }
            ]
          },
          {
            "condition": "withPersistDominantColor",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "DominantColorPersister_project"
              }
            ]
          },
          (v10/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThemeSetterQuery",
    "selections": [
      (v3/*: any*/),
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "args": (v7/*: any*/),
            "kind": "LinkedField",
            "name": "background",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraActiveBackgroundDetailsResult"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "colorValue"
                  }
                ],
                "type": "JiraColorBackground"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "gradientValue"
                  }
                ],
                "type": "JiraGradientBackground"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraCustomBackground",
                    "kind": "LinkedField",
                    "name": "customBackground",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "mediaApiFileId"
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "durationInSeconds",
                            "value": 900
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "mediaReadToken",
                        "storageKey": "mediaReadToken(durationInSeconds:900)"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "sourceType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "sourceIdentifier"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "altText"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "dominantColor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "brightness"
                      }
                    ]
                  }
                ],
                "type": "JiraMediaBackground"
              }
            ]
          },
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "condition": "withPersistDominantColor",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "canEditProjectConfig",
                "args": (v8/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "73217ad492b967e01ebeed7cedf9991eec990162d13ac0a42beb8f9526209dd7",
    "metadata": {},
    "name": "ThemeSetterQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "101c6f15c07b63a71c2001f02f0e684a";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
